import { defineColumns } from '@juvare/platform-shared/features/storage';
import { defaultMhcSpecialtyData } from '../../../../backend/config/classifiers/defaults/DefaultMhcSpecialtyData';
import { mhcSpecialtySchema } from '../../../../backend/config/classifiers/types';
import { allowManageCredentialingClassifiers } from '../../../../backend/features/permissions';
import { AuthError } from '@juvare/platform-app/App';
import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
export const mhcSpecialtyEntityName = 'mhcSpecialty';
const mhcSpecialtyColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export function defineMhcSpecialtyClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 3,
            columns: mhcSpecialtyColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (context, params) => {
                return Object.assign(Object.assign({}, transformClassifierColumns(params)), { search: [params.data.name, params.data.status].join(' ') });
            },
            onAnonymousAuthList: (appState, response) => response,
            onAuthPost: (appState, userState) => {
                if (!allowManageCredentialingClassifiers(userState)) {
                    throw new AuthError('Unauthorized');
                }
            },
        },
        defaultData: defaultMhcSpecialtyData,
        publicData: true,
    }, mhcSpecialtySchema);
}
